function Skills() {
    return (
        <section className="skills-container">
            <h2 className="section-title">Skills</h2>

            <section className="skills-category">
                <h3>Frontend Development</h3>
                <p>
                    HTML5 • CSS3 • JavaScript • React • Bootstrap • Responsive Web Design
                </p>
            </section>

            <section className="skills-category">
                <h3>Backend Development</h3>
                <p>
                    Node.js • Express.js • Java • GraphQL
                </p>
            </section>

            <section className="skills-category">
                <h3>Databases</h3>
                <p>
                    MongoDB • MySQL • SQL Server
                </p>
            </section>

            <section className="skills-category">
                <h3>Digital Technology</h3>
                <p>
                    Web Application Development • CMS Platforms • Website Development • 
                    ADA/WCAG Accessibility • SaaS • Technical Product Ownership • 
                    Technology Operations
                </p>
            </section>
        </section>
    );
}

export default Skills;